import React from "react";
import CostCenterList from "./CostCenterList";
import RemovableCostCenterLabel from "components/Removables/RemovableCostCenter";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

const CostCenterModalPicker = (props: ModalPickerProps<server.dto.CostCenter>) => {
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={RESX.CostCenter.CostCenters}
    modalSize="mini"
    renderModalContent={(closeModal) => <CostCenterList
      onItemSelected={(costCenter) => {
        closeModal();
        props.onChange(costCenter);
      }}
    />}
    renderRemovable={RemovableCostCenterLabel}
    {...props}
  />;
};

export default CostCenterModalPicker;